export default __webpack_public_path__ + "static/media/property_50.6b629aea.png";